module.exports = __webpack_public_path__ + "static/media/ic_callPlus.1f928ae7.svg";